import { BiChevronDown } from "react-icons/bi";
import { Button, Select } from "../../components/Form";
import TwoColumRow from "../../components/TwoColumRow";
// import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Loading from "../Loading";
import { useDispatch, useSelector } from "react-redux";
import { getAllTemplates } from "../../redux/features/templateSlice";
import { useParams } from "react-router-dom";
import { usePatient } from "../../customHooks/queries/usePatient";

const RegistroDocumentoModal = ({ onSave, onClose, data: visitas }) => {
  const dispatch = useDispatch();
  const { id: patient_id } = useParams();
  const { data: patient, isLoading: isLoadingPatient } = usePatient(patient_id);
  const {
    data: templates,
    isLoading: isLoadingTemplate,
    error
  } = useSelector((state) => state.templates);

  const [tiposDocumentos, setTiposDocumentos] = useState([])
  const [tipoDocumento, setTipoDocumento] = useState([]);
  const [contenido, setContenido] = useState('');
  const [contenidoProcesado, setContenidoProcesado] = useState('');

  useEffect(() => {
    dispatch(getAllTemplates());
    // dispatch(getVisitas(patient_id));
  }, [patient_id, dispatch]);

  useEffect(() => {
    if (templates && templates.length > 0) {
      const newTiposDocumento = templates.map((template, index) => {
        return {
          id: template.id,
          name: template.nombre,
          contenido: template.contenido
        };
      });

      setTipoDocumento(newTiposDocumento[0]);
      setTiposDocumentos(newTiposDocumento);
      setContenidoProcesado(procesarContenido(newTiposDocumento[0]?.contenido || ''));
    }
  }, [templates]);

  useEffect(() => {
    if (tipoDocumento?.contenido) {
      const procesado = procesarContenido(tipoDocumento.contenido);
      setContenido(procesado);
      setContenidoProcesado(procesado);
    }
  }, [tipoDocumento]);

  const procesarContenido = (rawContent) => {
    const today = new Date();
    const formatterCorto = new Intl.DateTimeFormat("es-BO", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const fechaCorta = formatterCorto.format(today);
    const ultimaVisita = visitas?.length
      ? visitas.reduce((max, current) =>
        current.id > max.id ? current : max
      )
      : null;
    if (!rawContent || !patient?.data) return rawContent;
    // El diagnóstico puede venir con varios items separados por "|" y, por datos viejos, con el texto
    // literal "null"/"undefined". Lo limpiamos: separamos, descartamos vacíos y "null"/"undefined",
    // y unimos con coma. Si no queda nada, se imprime una línea en blanco para completar a mano.
    const diagnostico =
      String(ultimaVisita?.diagnostico ?? "")
        .split("|")
        .map((d) => d.trim())
        .filter((d) => d && !/^(null|undefined)$/i.test(d))
        .join(", ") || "________________";
    return rawContent
      .replace(/{nombre_completo}/g, `${patient.data.persona.nombre} ${patient.data.persona.apellidos}`)
      .replace(/{hoy}/g, fechaCorta)
      .replace(/{diagnostico}/g, diagnostico)
      .replace(/{nacimiento}/g, patient.data.persona.fecha_nacimiento.split("T")[0]);
  };

  const handleSubmit = async () => {
    const today = new Date();
    const fechaCorta = today.toISOString().split("T")[0];
    const dataToSend = {
      contenido_procesado: contenidoProcesado,
      fecha: fechaCorta,
      template_id: tipoDocumento?.id,
    };
    onSave(dataToSend);
    onClose();
  };

  if (isLoadingPatient && isLoadingTemplate) return <Loading />;

  if (error) return (
    <div className="text-red-500 p-4">
      Error: {error.message || "Error al cargar templates"}
    </div>
  );

  return (
    <div className="flex-colo gap-6">
      <div className="flex w-full flex-col gap-3">
        <p className="text-black text-sm">Tipo de Documento</p>
        <Select
          selectedPerson={tipoDocumento}
          setSelectedPerson={setTipoDocumento}
          datas={tiposDocumentos}
        >
          <div className="w-full flex-btn text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
            {tipoDocumento?.name} <BiChevronDown className="text-xl" />
          </div>
        </Select>
      </div>
      <div className="flex w-full flex-col gap-3">
        <div className="max-h-[50vh] overflow-y-auto">
          <CKEditor
            editor={ClassicEditor}
            onReady={editor => {
              // Fuerza estilos via JS
              editor.editing.view.change(writer => {
                writer.setStyle('padding-left', '40px', editor.editing.view.document.getRoot());
                writer.setStyle('list-style-position', 'outside', editor.editing.view.document.getRoot());
              });
            }}
            data={contenido}
            onChange={(event, editor) => {
              setContenidoProcesado(editor.getData());
            }}
            config={{
              toolbar: {
                items: [
                  'undo', 'redo', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList'
                ],
              },
            }}
          />
        </div>
      </div>
      <TwoColumRow>
        <Button
          label={"Cancelar"}
          onClick={onClose}
        />
        <Button
          label={`Guardar Registro`}
          onClick={handleSubmit}
        />
      </TwoColumRow>
    </div >
  )
}

export default RegistroDocumentoModal;